import React from 'react';
import { Flex, Box, Link, Button } from '@chakra-ui/react';
import BackgroundImage from '../../components/shared/BackgroundImage';
import VideoPlayer from '../../components/shared/VideoPlayer';
import SectionTitle from '../../components/shared/SectionTitle';
import HeroImage from '../../images/bg-diagonal.webp';

const TransformHero = () => (
  <BackgroundImage imageUrl={HeroImage}>
    <Flex
      w="100%"
      minH="950px"
      h="fit-content"
      px={['4', '16']}
      pb={['6']}
      alignItems="center"
      justifyContent="center"
      textAlign="center"
    >
      <Box maxW="4xl" color="white" pt={['0', '20']}>
        <SectionTitle
          title="Transform your business"
          subTitle="Streamline your workflow from sales to production with new features in the Transform Plan."
        />
        <Link href="https://calendly.com/hover-sdr/hover-transform">
          <Button size="lg" mb="7">
            Schedule a Demo
          </Button>
        </Link>
        <Box maxW="xl" mx="auto">
          <VideoPlayer
            borderRadius="10px"
            title="HOVER - Transform Plan"
            src="https://fast.wistia.net/embed/iframe/icg4mc2i2t"
          />
        </Box>
      </Box>
    </Flex>
  </BackgroundImage>
);
export default TransformHero;
